// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import { shallowRef } from "vue";
import individualDiagnose from '../../../../share/util/individualDiagnose';
import config from '../../../../share/config';
import session from '../../../../share/session';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import error from '../../../../common/nodejs/errors';

import requirement123 from '../../../../components/vue/individualWorkSupport/Requirement123.vue';
import requirement124 from '../../../../components/vue/individualWorkSupport/Requirement124.vue';

/** 各フェーズ定義 */
const PHASE = {
  MODE_SELECT: 'mode-select',
  WAITING_LINE: 'waiting_line',
  BRAKE_CONTROL_PROHIBITED: 'brake_control_prohibited',
  BRAKE_CONTROL_RESUMED: 'brake_control_resumed',
  ACCUM_DOWN_DRIVE: 'accum_down_drive',
  EXEC_WRITING: 'exec_writing',
  STOP_LINE: 'stop_line',
  WAITING_SYS_CONDITIONS: 'waiting_sys_conditions',
  WAITING_SYS_CAP_RESERVOIR_TANK: 'waiting_sys_cap_reservoir_tank',
  WAITING_SYS_BRAKE_FLUID: 'waiting_sys_brake_fluid',
  CONF_ACCUM_BOOST_EXEC: 'conf_accum_boost_exec',
  INIT_AIR_BLEED_STATE: 'init_air_bleed_state',
  EXEC_ACCUM_BOOST: 'exec_accum_boost',
  CONF_INBOOST_EXEC: 'conf_inboost_exec',
  SEQ1: 'seq1',
  SEQ2: 'seq2',
  CONF_INBOOST_FIN: 'conf_inboost_fin',
  STOP_SYS: 'stop_sys',
  WAITING_ACTU: 'waiting_actu',
  EXEC_ACTU: 'exec_actu',
  CHECK_EXEC_ACTU: 'check_exec_actu',
  STOP_ACTU: 'stop_actu',
  ERROR: 'error',
  CONNECT_FAILED: 'connectionFailed'
};

const MAX_TIMER = 60000;
const INTERVAL = 1000;

export default {
  name: 'requirement120',
  data() {
    return {
      phase: PHASE.MODE_SELECT,
      isLoading: false,
      elapsedTime: null,
      timer: 0,
      timerInfo: '',
      executeTimer: 0,
      timeoutTimer: null,
      seq2Info: '',
      modeList: [],
      selectedMode: '',
      // 実行回数カウンター
      counter: 1,
      // ブレーキシステムエア抜きからブレーキラインエア抜きを呼び出したフラグ
      isSysWorking: false,
      currentWizard: '',
      ws120i18nWsKey: '',
      ws120workSupportId: '',
      isMenuTitle: this.$t(`${this.i18nWsKey}.menu_title`),
      isCancel: false,
      // 機能を選択していないときにOKボタンを非活性とするフラグ
      isNotSelected: true,
      isNonDefaultSessionSucceed: true,
      isFirst: true,
      isBreakSucceed: false,
      isTimeout: false,
      modal_work_support_120: false
    };
  },
  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true },
  },

  components: {
    'requirement123-vue': requirement123,
    'requirement124-vue': requirement124,
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),
    /**
     * ダイアログのヘッダー色
     */
    // HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
    /* eslint-disable complexity */
    headerColor() {
      switch (this.phase) {
        case PHASE.ERROR:
        case PHASE.CONNECT_FAILED:
          return 'danger';
        case PHASE.STOP_LINE:
        case PHASE.STOP_SYS:
        case PHASE.STOP_ACTU:
          return 'success';
        case PHASE.MODE_SELECT:
        case PHASE.WAITING_LINE:
        case PHASE.BRAKE_CONTROL_PROHIBITED:
        case PHASE.BRAKE_CONTROL_RESUMED:
        case PHASE.ACCUM_DOWN_DRIVE:
        case PHASE.EXEC_WRITING:
        case PHASE.WAITING_SYS_CONDITIONS:
        case PHASE.WAITING_SYS_CAP_RESERVOIR_TANK:
        case PHASE.WAITING_SYS_BRAKE_FLUID:
        case PHASE.CONF_ACCUM_BOOST_EXEC:
        case PHASE.INIT_AIR_BLEED_STATE:
        case PHASE.EXEC_ACCUM_BOOST:
        case PHASE.CONF_INBOOST_EXEC:
        case PHASE.SEQ1:
        case PHASE.SEQ2:
        case PHASE.CONF_INBOOST_FIN:
        case PHASE.WAITING_ACTU:
        case PHASE.EXEC_ACTU:
        case PHASE.CHECK_EXEC_ACTU:
        default:
          return 'secondary';
      }
    }
  },

  mounted() {
    // 機能一覧作成
    this.setModeSelectList();
    this.init();
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),

    /**
     * 初期化処理
     * */
    init() {
      this.systemId = individualDiagnose.getCurrentSystemId(this);
      this.modal_work_support_120 = true;
    },

    /**
     * 機能選択一覧表示
     * */
    setModeSelectList() {
      this.modeList = [
        { value: "line", text: this.$t(`individual.label_mode_line`) },
        { value: "sys", text: this.$t(`individual.label_mode_sys`) },
        { value: "actu", text: this.$t(`individual.label_mode_actu`) }
      ];
    },

    /**
     * 機能が選択されたときにOKボタンを押下できるようにする
     */
    handleSelected() {
      this.isNotSelected = false;
    },

    /**
     * 機能が選択され、OKボタン押下時の処理
     * */
    selectMode() {
      if (this.selectedMode === 'line') {
        this.phase = PHASE.WAITING_LINE;
      } else if (this.selectedMode === 'sys') {
        this.phase = PHASE.WAITING_SYS_CONDITIONS;
      } else if (this.selectedMode === 'actu') {
        this.phase = PHASE.WAITING_ACTU;
      }
    },

    /**
     * 待機画面でキャンセルボタンを押下したときの処理
     */
    async stopProcess() {
      // ブレーキシステムエア抜きから遷移してきた場合、DefaultSession遷移を実施
      if (this.isSysWorking) {
        await this.exit();
      } else {
        this.closeWizard();
      }
    },

    // ==================================================================================
    // ブレーキラインエア抜き
    // ==================================================================================

    /**
     * ブレーキ制御禁止
     * ルーチン実行処理
     * 
     * ※リクエストBody
     * type: 'execute-line' NonDefaultSession含む
     *     : 'execute-sys'  NonDefaultSession除く
     * */
    async executeLine() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const type = !this.isSysWorking ? 'execute-line' : 'execute-sys';
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: type,
            is_first: this.isFirst
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        // response が存在する場合、正常判定を行う(存在しない場合は共通エラー)
        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              this.phase = PHASE.BRAKE_CONTROL_PROHIBITED;
              break;
            case config.STATUS_WSP_FAILED:
              // NonDefaultSession遷移で異常終了の場合、DefaultSession遷移を実行せずエラー画面に遷移
              switch (response.data.async_code) {
                case error.WSP_INITIALIZE_FAILED:
                  this.phase = PHASE.ERROR;
                  break;
                default:
                  await this.showCommonError();
                  break;
              }
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
        this.isFirst = false;
      }
    },

    /**
     * ブレーキ制御再開
     * ルーチン停止処理
     */
    async stopLine() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'stop'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        // response が存在する場合、正常判定を行う(存在しない場合は共通エラー)
        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              this.phase = PHASE.BRAKE_CONTROL_RESUMED;
              break;
            case config.STATUS_WSP_FAILED:
              await this.showCommonError();
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * ストップランプSW状態監視
     * データ読出し処理
     */
    async readAccum() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'read'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        // response が存在する場合、正常判定を行う(存在しない場合は共通エラー)
        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              await this.executeProcessAccum();
              break;
            case config.STATUS_WSP_FAILED:
              await this.showCommonError();
              break;
            default:
              await this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * アキュムレータダウン駆動画面処理
     */
    async executeProcessAccum() {
      this.timerInfo = this.$t(`${this.i18nWsKey}.REQ_WS_120_TXT_4`).replace("$TIME$", 0);
      this.phase = PHASE.ACCUM_DOWN_DRIVE;
      this.elapsedTime = setInterval(() => {
        this.timer += INTERVAL;
        this.timerInfo = this.$t(`${this.i18nWsKey}.REQ_WS_120_TXT_4`).replace("$TIME$", Math.ceil(this.timer / 1000));
      }, INTERVAL);
      await this.executeAccum();
      clearInterval(this.elapsedTime);
    },

    /**
     * アキュムレータダウン駆動
     * ルーチン実行（駆動開始、駆動停止）処理
     * */
    async executeAccum() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'execute_accum'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        // response が存在する場合、正常判定を行う(存在しない場合は共通エラー)
        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              await this.toExecWriting();
              break;
            case config.STATUS_WSP_FAILED:
              await this.showCommonError();
              break;
            default:
              await this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * データ書込み実行中画面(ヘッダーのみ表示)
     */
    async toExecWriting() {
      this.phase = PHASE.EXEC_WRITING;
      await this.writeLine();
    },

    /**
     * 停止(ブレーキラインエア抜き)
     * データ書込み処理
     * */
    async writeLine() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'write-line'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        // response が存在する場合、正常判定を行う(存在しない場合は共通エラー)
        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：停止画面(ブレーキラインエア抜き)を表示
              this.phase = PHASE.STOP_LINE;
              break;
            case config.STATUS_WSP_FAILED:
              await this.showCommonError();
              break;
            default:
              await this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * エラー画面表示処理(DefaultSession遷移の結果に関わらずエラー表示)
     */
    async showCommonError() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'exit'
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
        );

        // 通信結果に関わらずエラー画面を表示
        this.phase = PHASE.ERROR;
      } finally {
        this.isLoading = false;
      }
    },

    // ==================================================================================
    // ブレーキシステムエア抜き
    // ==================================================================================

    /**
     * 待機画面1OKボタン押下
     */
    toCapReservoirTank() {
      this.phase = PHASE.WAITING_SYS_CAP_RESERVOIR_TANK;
    },

    /**
     * 待機画面2OKボタン押下
     */
    toBrakeFluid() {
      this.phase = PHASE.WAITING_SYS_BRAKE_FLUID;
    },

    /**
     * 待機画面3OKボタン押下
     */
    toExecutionConfirmation() {
      this.phase = PHASE.CONF_ACCUM_BOOST_EXEC;
    },

    /**
     * エア抜き状態初期化画面処理
     */
    async executeProcessInit() {
      this.phase = PHASE.INIT_AIR_BLEED_STATE;
      //NonDefaultSession遷移+データ書込み
      await this.initialize();
    },

    /**
     * エア抜き状態初期化
     * データ書込み(NonDefaultSession遷移を含む)処理
     */
    async initialize() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'write_session_transition'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        // response が存在する場合、正常判定を行う(存在しない場合は共通エラー)
        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              await this.executeProcessAccumBoost();
              break;
            case config.STATUS_WSP_FAILED:
              // NonDefaultSession遷移で異常終了の場合、DefaultSession遷移を行うフラグをfalseにする
              if (response.data.async_code === error.WSP_INITIALIZE_FAILED) {
                this.isNonDefaultSessionSucceed = false;
              }
              this.phase = PHASE.ERROR;
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
        this.isFirst = false;
      }
    },

    /**
     * エア抜き実行画面(アキュムレータ・ブースター間エア抜き)処理
     */
    async executeProcessAccumBoost() {
      this.timerInfo = this.$t(`${this.i18nWsKey}.REQ_WS_120_TXT_12_0001`).replace("$TIME$", 0);
      this.phase = PHASE.EXEC_ACCUM_BOOST;
      this.elapsedTime = setInterval(() => {
        this.timer += INTERVAL;
        this.timerInfo = this.$t(`${this.i18nWsKey}.REQ_WS_120_TXT_12_0001`).replace("$TIME$", Math.ceil(this.timer / 1000));
      }, INTERVAL);
      await this.executeAccumBoost();
      clearInterval(this.elapsedTime);
      this.timer = 0;
      this.timerInfo = '';
    },

    /**
     * エア抜き実行(アキュムレータ・ブースター間エア抜き)
     *  ルーチン実行処理
     * */
    async executeAccumBoost() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'execute_accum_boost'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        // response が存在する場合、正常判定を行う(存在しない場合は共通エラー)
        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              this.phase = PHASE.CONF_INBOOST_EXEC;
              this.executeTimer = response.data.user_data.wait_time;
              break;
            case config.STATUS_WSP_FAILED:
              this.phase = PHASE.ERROR;
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * エア抜きシーケンス1画面処理
     */
    async executeProcessInBoost() {
      // 実行回数はフロント側で管理
      this.counterInfo = this.$t(`${this.i18nWsKey}.REQ_WS_120_TXT_14_0001`).replace("$TIMES$", this.counter);
      this.timerInfo = this.counterInfo.replace("$TIME$", MAX_TIMER / 1000);

      // エア抜きシーケンス1画面を表示
      this.phase = PHASE.SEQ1;
      this.elapsedTime = setInterval(() => {
        this.timer += INTERVAL;
        this.timerInfo = this.counterInfo.replace("$TIME$", Math.ceil((MAX_TIMER - this.timer)) / 1000);
      }, INTERVAL);

      // 指定時間（※データ書込み時取得）経過後、エラーへ遷移
      this.timeoutTimer = setTimeout(async () => {
        this.isTimeout = true;
        await this.executeBreakProcess();
        // エラー(ブレーキシステムエア抜き)を表示
        this.phase = PHASE.ERROR;
        clearTimeout(this.timeoutTimer);
        this.timeoutTimer = null;
      }, this.executeTimer);
      await this.executeInBoost();
      clearInterval(this.elapsedTime);
      this.timer = 0;
      this.timerInfo = '';
    },

    /**
     * エア抜きシーケンス1
     * ルーチン実行、ルーチン結果確認処理
     */
    async executeInBoost() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'execute_inboost'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        // response が存在する場合、正常判定を行う(存在しない場合は共通エラー)
        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          if (this.timeoutTimer) {
            clearTimeout(this.timeoutTimer);
            this.timeoutTimer = null;
          }
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              if (!this.isCancel) {
                // エア抜きシーケンス2画面を表示
                this.seq2Info = this.$t(`${this.i18nWsKey}.REQ_WS_120_TXT_15_0002`).replace("$TIMES$", this.counter);
                this.phase = PHASE.SEQ2;
              } else {
                // HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
                /* eslint-disable max-depth */
                if (this.isTimeout) {
                  // タイムアウト時は何もしない
                  return;
                }
                await this.exit();
              }
              break;
            case config.STATUS_WSP_FAILED:
              this.phase = PHASE.ERROR;
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        // タイムアウト時、または中止がされていない場合はスピナーを非表示
        if (!this.isCancel) {
          this.isLoading = false;
        }

      }
    },

    /**
     * エア抜きシーケンス2
     * 
     * 実行回数によってOKボタン押下時の分岐
     */
    async toSeq1OrConf() {
      // 3回未満:エア抜き実行、3回目:エア抜き完了確認画面を表示
      if (this.counter < 3) {
        this.counter++;
        await this.executeProcessInBoost();
      } else if (this.counter === 3) {
        this.phase = PHASE.CONF_INBOOST_FIN;
      }
    },

    /**
     * エア抜き実行中断処理の呼び出し
     */
    async executeBreakProcess() {

      // Responseが返ってくるまで エア抜き実行中断処理を繰り返す
      const repeatExecuteBreak = async () => {
        if (this.isBreakSucceed) {
          return;
        }
        this.executeBreak();
        setTimeout(repeatExecuteBreak, 15000); // 15秒後に再度実行
      };

      repeatExecuteBreak(); // 初回の呼び出し
    },

    /**
     * エア抜き実行中断処理
     */
    async executeBreak() {
      try {
        this.isLoading = true;
        this.isCancel = true;
        clearInterval(this.elapsedTime);
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'execute_inboost-stop'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          this.isBreakSucceed = true;
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * 待機画面(ブレーキラインエア抜き)を表示（エア抜き完了確認画面OKボタン押下）
     */
    toWaitingLine() {
      this.isSysWorking = true;
      this.selectedMode = 'line';
      this.phase = PHASE.WAITING_LINE;
    },


    /**
     * WS.123もしくはWS.124の処理が終了後、次、起動するシステムを分岐
     * @param {*} event 他WorkSupportからの返り値
     */
    async ws120Return(event) {
      switch (event) {
        // WS.124で正常終了した場合、WS.123（リニア弁オフセット学習）を起動
        case 'ws124':
          this.currentWizard = shallowRef(requirement123);
          this.ws120i18nWsKey = 'wsEBB.12301';
          this.ws120workSupportId = this.workSupportId;
          break;
        // WS.123で正常終了した場合、WS.120モーダルを起動し、ブレーキシステムエア抜き停止処理を実行
        case 'ws123':
          this.phase = PHASE.EXEC_WRITING;
          this.systemId = individualDiagnose.getCurrentSystemId(this);
          this.modal_work_support_120 = true;
          await this.writeSys();
          break;
        default:
          this.exit();
          break;
      }
    },

    /**
     * 停止(ブレーキシステムエア抜き)
     * データ書込み処理
     */
    async writeSys() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'write-sys'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        // response が存在する場合、正常判定を行う(存在しない場合は共通エラー)
        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：停止画面を表示
              this.phase = PHASE.STOP_SYS;
              break;
            case config.STATUS_WSP_FAILED:
              this.phase = PHASE.ERROR;
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    // ==================================================================================
    // アクチュエータ強制リフレッシュ
    // ==================================================================================

    /**
     * 実行画面(アクチュエータ強制リフレッシュ)処理
     */
    async executeProcessActu() {
      this.phase = PHASE.EXEC_ACTU;
      await this.executeActu();
    },

    /**
     * アクチュエータ強制リフレッシュ実行
     * ルーチン実行(NonDefaultSession遷移を含む)処理
     */
    async executeActu() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'execute-actu'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        // response が存在する場合、正常判定を行う(存在しない場合は共通エラー)
        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              await this.checkExecutionProcessActu();
              break;
            case config.STATUS_WSP_FAILED:
              // NonDefaultSession遷移で異常終了の場合、DefaultSession遷移を行うフラグをfalseにする
              if (response.data.async_code === error.WSP_INITIALIZE_FAILED) {
                this.isNonDefaultSessionSucceed = false;
              }
              this.phase = PHASE.ERROR;
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
        this.isFirst = false;
      }
    },

    /**
     * 実行監視画面(アクチュエータ強制リフレッシュ)処理
     * 
     */
    async checkExecutionProcessActu() {
      this.timerInfo = this.$t(`${this.i18nWsKey}.REQ_WS_120_TXT_20_0001`).replace("$TIME$", 0);
      this.phase = PHASE.CHECK_EXEC_ACTU;
      this.elapsedTime = setInterval(() => {
        this.timer += INTERVAL;
        this.timerInfo = this.$t(`${this.i18nWsKey}.REQ_WS_120_TXT_20_0001`).replace("$TIME$", Math.ceil(this.timer / 1000));
      }, INTERVAL);
      await this.checkExecutionActu();
      clearInterval(this.elapsedTime);
    },

    /**
     * 実行監視(アクチュエータ強制リフレッシュ)
     * ルーチン結果確認処理
     */
    async checkExecutionActu() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'execute_check'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        // response が存在する場合、正常判定を行う(存在しない場合は共通エラー)
        if (response) {
          // エラーコールバックが呼ばれず、completed / failed が返ってきてポーリングが終了した時のみ、最終的な GET response が返ってくる。
          // エラーコールバックが呼ばれた場合は、null になる。
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              await this.stopActu();
              break;
            case config.STATUS_WSP_FAILED:
              this.phase = PHASE.ERROR;
              break;
            default:
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * 停止(アクチュエータ強制リフレッシュ)
     */
    async stopActu() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'exit'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );
        // GET結果に関わらず停止画面を表示
        this.phase = PHASE.STOP_ACTU;
      } finally {
        this.isLoading = false;
      }
    },

    // ==================================================================================
    // 共通
    // ==================================================================================

    /**
     * 停止画面、エラー画面のOK押下時の処理
     */
    async stop() {
      if (this.isSysWorking) {
        // ブレーキシステムエア抜きからブレーキラインエア抜きを呼び出したときの停止処理
        // WS.124(バックアップメモリ削除)を起動
        // WS.120モーダルを非表示
        this.selectedMode = 'sys';
        this.currentWizard = shallowRef(requirement124);
        this.ws120i18nWsKey = 'wsEBB.12401';
        this.ws120workSupportId = this.workSupportId;
        this.isSysWorking = false;
        this.modal_work_support_120 = false;
      } else {
        if (this.isNonDefaultSessionSucceed) {
          await this.exit();
        } else {
          this.closeWizard();
        }
      }
    },

    /**
     * Wizardを閉じる
     */
    closeWizard() {
      this.$emit('close-wizard');
      this.modal_work_support_120 = false;
    },

    /**
     * Exit処理(機能終了)
     */
    async exit() {
      try {
        this.isLoading = true;
        const token = session.getToken();
        await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: 'exit',
            is_first: this.isFirst
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );
        // GET結果に関わらず機能を終了
        this.closeWizard();
      } finally {
        this.isLoading = false;
        this.isFirst = false;
      }
    },

    /**
     * その他エラー発生時の表示
     */
    showUnexpectedError() {
      // エラー画面に遷移する
      this.phase = PHASE.CONNECT_FAILED;
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; if (this.isErrorCheck) this.showUnexpectedError(); },
      );
    },
  }
};